import { DeleteForever, EditOutlined } from "@mui/icons-material";
import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import AddEmployeeDialog from "../../components/add-employee-dialog";
import useEmployees from "../../hooks/useEmployees";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setDeleteDialog } from "../../store/ui.store";

const columns = [
  { id: "name", label: "Name" },
  { id: "employmentType", label: "Employment Type" },
  { id: "role", label: "Role" },
  { id: "mobile", label: "Mobile" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions" },
];

export default function EmployeesPage() {
  const dispatch = useAppDispatch();
  const { getEmployees, deleteEmployee } = useEmployees();
  const employees = useAppSelector((state) => state.data.employees);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // const handleMenuItemClick = async (docId: string, status: string) => {
  //   await updateLead(docId, { status: status });
  //   setAnchorEl(null);
  // };

  useEffect(() => {
    getEmployees();
  }, [getEmployees]);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        }}
      >
        <Typography variant="h6" id="tableTitle" component="div">
          Employees
        </Typography>
        <Button variant="contained" size="small" onClick={() => setOpen(true)}>
          Add Employee
        </Button>
      </Toolbar>
      {open && <AddEmployeeDialog open={open} onClose={() => setOpen(false)} />}
      <TableContainer
        sx={{
          height: "calc(100vh-250px)",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {employees
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover tabIndex={-1} key={row.mobile}>
                    <TableCell>{row.firstName}</TableCell>
                    <TableCell>{row.employmentType}</TableCell>
                    <TableCell>{row.role}</TableCell>
                    <TableCell>{row.mobile}</TableCell>
                    <TableCell>
                      {row.loggedIn === false
                        ? "Pending"
                        : row.isActive
                        ? "Active"
                        : "In Active"}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Update">
                        <IconButton
                          color="primary"
                          disabled={row.role === "Admin"}
                        >
                          <EditOutlined />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          disabled={row.role === "Admin"}
                          onClick={() => {
                            dispatch(
                              setDeleteDialog({
                                show: true,
                                onDelete: () => {
                                  deleteEmployee(row.uid);
                                },
                              })
                            );
                          }}
                        >
                          <DeleteForever />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={employees.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
